export default "__VITE_ASSET__1ea22699__$_?nuxt_component=async__"